import { Box } from "@mui/system";
import { useRef } from "react";

import AppModalTitle from "@/common/components/Modals/AppModalTitle";
import { useEntityInputFormInfo } from "@/common/hooks/entity/useEntityInputFormInfo";

import AppModalContent from "../../Modals/AppModalContent";
import {
  BaseEntityCreateUpdateModal,
  BaseEntityCreateUpdateModalInheritableProps,
} from "../components/BaseEntityCreateUpdateModal";
import VisualInspectionCreateUpdate, {
  VisualInspectionCreateUpdateHandle,
  VisualInspectionCreateUpdateProps,
} from "./VisualInspectionCreateUpdate";

type Props = {
  createUpdateProps: VisualInspectionCreateUpdateProps;
} & BaseEntityCreateUpdateModalInheritableProps;

export default function VisualInspectionCreateUpdateModal({
  createUpdateProps,
  ...modalProps
}: Props) {
  const formInfo = useEntityInputFormInfo({ entityId: createUpdateProps.visualInspectionId });
  const formWrapperRef = useRef<VisualInspectionCreateUpdateHandle | null>(null);

  return (
    <BaseEntityCreateUpdateModal
      fullWidth
      maxWidth='lg'
      {...modalProps}
      formWrapperRef={formWrapperRef}
    >
      {(params) => (
        <>
          <AppModalTitle onClose={params.close}>
            {formInfo.isCreate ? "Create new" : "Edit"} visual inspection
          </AppModalTitle>
          <AppModalContent>
            <Box sx={{ py: 1 }}>
              <VisualInspectionCreateUpdate ref={formWrapperRef} {...createUpdateProps} />
            </Box>
          </AppModalContent>
        </>
      )}
    </BaseEntityCreateUpdateModal>
  );
}
